module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXMAAAA3CAYAAAD+BKpcAAABKklEQVR4nO3U0UmCARiF4fM7QBhGoZhBjdA+Dd0CjuAIhReCiN33HZ5nggMH3iVf358B4L87JTkm+bm3c+U+gBEekxz+GirmAHM8JdnfWyvmALO8JNneLhZzgHl2SZ6vV4s5wEyvSTaX5WIOMNdbknXEHGC0Jcl7kgcxB5jtHPQPMQeYbyXmAAXEHKCAmAMUEHOAAmIOUEDMAQqIOUABMQcoIOYABcQcoICYAxQQc4ACYg5QQMwBCog5QAExBygg5gAFxByggJgDFBBzgAJiDlBAzAEKiDlAATEHKCDmAAXEHKCAmAMUEHOAAmIOUEDMAQqIOUABMQcoIOYABcQcoICYAxQQc4ACYg5QQMwBCog5QAExBygg5gAFxByggJgDFBBzgAJiDjBdkl9NFgYT39zjsAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx_1.png
// module id = iD/h
// module chunks = 1